import ng from 'angular';
import acpCore from 'core';
import { AcpAdaChatbotPlugin } from './ada-chatbot-plugin';
import { acpAdaChatbotComponent } from './ada-chatbot-component';
import './styles/${theme}/core.scss';

export const acpComponentAdaChatbotDomain = ng
  .module('acp.component.ada-chatbot-module', [acpCore.name])
  .component('adaChatbot', acpAdaChatbotComponent)
  .service('acpAdaChatbotPlugin', AcpAdaChatbotPlugin);

export { AcpAdaChatbotPlugin };

export default acpComponentAdaChatbotDomain;
